export default __webpack_public_path__ + "static/media/Maithili_am_1.271a899a.mp3";